import React from 'react';
import { makeStyles } from '@material-ui/styles';
import useScaler from '../hooks/Scaler';
const useStyles = makeStyles({
  root: {
    position: 'absolute',
    pointerEvents: 'none',
    height: ({ height }) => height,
    margin: ({ vMargin, hMargin }) => `${vMargin}px ${hMargin}px`,
    top: 0,
    transform: ({ transform }) => transform,
    transformOrigin: ({ transformOrigin }) => transformOrigin,
    width: ({ width }) => width,
  },
});
const Layout = ({ children }) => {
  const { width, height, transform, transformOrigin, vMargin, hMargin } = useScaler();
  const { root } = useStyles({
    width,
    height,
    transform,
    transformOrigin,
    vMargin,
    hMargin,
  });
  return <div className={root}>{children}</div>;
};

export default Layout;
